<template>
  <div>
    <div style="overflow: hidden">
      <div class="wrapper_all wrapper_app_job flex-col">
        <div class="advanced-head flex-row-space-between">
          <div class="headLeft flex">
            <span class="mr20">进阶管理</span>
            <span class="small">学科</span>
            <el-select
                style="width:100px;margin: 0px 10px"
                v-model="subjectId"
                placeholder="请选择"
                @change="changeSubjectId"
            >
              <el-option
                  v-for="item in teacherSubjectList"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="headright">
            <el-menu
                :default-active="menuIndex"
                mode="horizontal"
                active-text-color="#51A5F7"
                @select="changeMenuIndex"
            >
              <el-menu-item index="base">基础进阶</el-menu-item>
              <el-menu-item index="level">水平进阶</el-menu-item>
              <el-menu-item index="check">批改</el-menu-item>
              <el-menu-item index="appeal-review">申诉审核</el-menu-item>
              <el-menu-item index="check-review">自批审核</el-menu-item>
              <el-menu-item index="setting">设置</el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="advanced-content h100">
          <!--基础进阶-->
          <div v-show="'base' == menuIndex" class="h100">
            <advance-base :is-init-flag="advanceBaseFlag" @go-setting="goSetting"></advance-base>
          </div>
          <!--水平进阶-->
          <div v-show="'level' == menuIndex" class="h100">
            <advance-level :is-init-flag="advanceLevelFlag"></advance-level>
          </div>

          <!--批改-->
          <div v-show="'check'==menuIndex" class="h100">
            <advance-check :is-init-flag="advanceCheckFlag"></advance-check>
          </div>

          <!--申诉审核-->
          <div v-show="'appeal-review'==menuIndex" class="h100">
            <advance-appeal-review :is-init-flag="advanceAppealReviewFlag"></advance-appeal-review>
          </div>

          <!--自批审核-->
          <div v-show="'check-review'==menuIndex" class="h100">
            <advance-check-review :is-init-flag="advanceCheckReviewFlag"></advance-check-review>
          </div>

          <!--设置-->
          <div v-show="'setting' == menuIndex" class="h100">
            <student-management></student-management>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import advanceBase from './advanceBase';
import advanceLevel from './advanceLevel';
import advanceCheck from './advanceCheck';
import advanceAppealReview from './advanceAppealReview';
import advanceCheckReview from './advanceCheckReview';
import studentManagement from '../office/student_management';

export default {
  name: 'advanced2',
  components: {
    advanceBase, advanceLevel, advanceCheck, advanceAppealReview, advanceCheckReview, studentManagement,
  },
  data() {
    return {
      menuIndex: 'base',
      advanceBaseFlag: true,
      advanceLevelFlag: false,
      advanceCheckFlag: false,
      advanceAppealReviewFlag: false,
      advanceCheckReviewFlag: false,

      // 学科
      teacherSubjectList: [], //学科列表
      subjectId: '', //学科ID
    };
  },
  methods: {
    changeMenuIndex(value) {
      if (value != this.menuIndex) {
        this.menuIndex = value;
        this.changeFlag();
      }
    },
    changeFlag() {
      // 初始化基础进阶
      if ('base' == this.menuIndex) {
        this.advanceBaseFlag = !this.advanceBaseFlag;
      }

      // 初始化水平进阶
      if ('level' == this.menuIndex) {
        this.advanceLevelFlag = !this.advanceLevelFlag;
      }

      // 初始化批改
      if ('check' == this.menuIndex) {
        this.advanceCheckFlag = !this.advanceCheckFlag;
      }

      // 初始化申诉审核
      if ('appeal-review' == this.menuIndex) {
        this.advanceAppealReviewFlag = !this.advanceAppealReviewFlag;
      }

      // 初始化自批审核
      if ('check-review' == this.menuIndex) {
        this.advanceCheckReviewFlag = !this.advanceCheckReviewFlag;
      }
    },
    goSetting() {
      this.menuIndex = 'setting';
    },
    //获取学科
    async getTeacherSubjectsList() {
      await this.axios.get('/bank/system/v1.0/teacher/subjects').then((res) => {
        if (res.data.code == 200) {
          this.teacherSubjectList = res.data.data;
          let advance = JSON.parse(sessionStorage.getItem('advance')) || {};
          if (this.teacherSubjectList.find(o => o.id == advance.subjectId)) {
            this.subjectId = advance.subjectId;
          } else {
            if (this.teacherSubjectList.length) {
              this.subjectId = this.teacherSubjectList[0].id;
            } else {
              this.subjectId = null;
            }
            advance.subjectId = this.subjectId;
            sessionStorage.setItem('advance', JSON.stringify(advance));
          }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    changeSubjectId() {
      let advance = {subjectId: this.subjectId};
      sessionStorage.setItem('advance', JSON.stringify(advance));
      this.changeFlag();
    },
    init() {
      this.getTeacherSubjectsList();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.wrapper_all {
  background: #ffffff;
  font-size: 16px;
}

.advanced-head {
  height: 60px;
  padding: 0px 20px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
  color: #403f3f;
  font-size: 18px;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal > .el-menu-item {
  color: #403f3f;
  font-size: 16px;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}

.advanced-content {
  height: 100%;
}

.h100 {
  height: 100%;
}

.advanced-content /deep/ .wrapper {
  margin: 0;
}

.advanced-content /deep/ .add_course_head {
  display: none;
}
</style>
<style>
.mr20 {
  margin-right: 20px;
}

.small {
  font-size: 16px;
}
</style>
